import { ChangeDetectionStrategy, Component, Directive, ViewEncapsulation } from '@angular/core';

@Directive({
  selector: 'ic-card-menu-item',
  host: { class: 'ic-card__menu-item' },
})
export class CardMenuItem {}

@Directive({
  selector: 'ic-card-title',
  host: { class: 'ic-card__title' },
})
export class CardTitle {}

@Directive({
  selector: 'ic-card-action',
  host: { class: 'ic-card__action' },
})
export class CardAction {}

@Directive({
  selector: 'ic-card-menu-header',
  host: { class: 'ic-card__menu-header' },
})
export class CardMenuHeader {}

@Directive({
  selector: 'ic-card-menu-footer',
  host: { class: 'ic-card__menu-footer' },
})
export class CardMenuFooter {}

@Component({
  moduleId: module.id,
  selector: 'ic-card-header',
  templateUrl: 'card-header.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardHeader {}

@Component({
  moduleId: module.id,
  selector: 'ic-card-footer',
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardFooter {}

@Component({
  moduleId: module.id,
  selector: 'ic-card-filter',
  template: '<ng-content></ng-content>',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardFilter {}

@Component({
  moduleId: module.id,
  selector: 'ic-card-menu',
  templateUrl: 'card-menu.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardMenu {}

@Component({
  moduleId: module.id,
  selector: 'ic-card-content',
  templateUrl: 'card-content.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardContent {}

@Component({
  moduleId: module.id,
  selector: 'ic-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {}



// WEBPACK FOOTER //
// ./src/app/layout/card/card.component.ts